import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';
import { getDayLabel, compareEventsByStartTime, entertainmentType, swimmingPage } from '../../utils';
import BookedEventCard from '../bookedEvent/BookedEventCard';
import EmptyEntertainmentCard from '../emptyEntertainmentCard/EmptyEntertainmentCard';
import './DailyEvents.scss';

const getDayLabelColor = (dateIndex) => {
  if (!dateIndex) return 'date-color-1';
  return `date-color-${(dateIndex % 4) + 1}`;
};

const getIsHappeningNext = (events, selectedStartDate, selectedId) => {
  if (!moment().isSame(selectedStartDate, 'day')) return false;
  if (!events || events.length === 0) return false;
  const todayEventsWithoutPastEvents = events.filter(({ startDate, isPastEvent }) => moment().isSame(startDate, 'day') && !isPastEvent);
  if (todayEventsWithoutPastEvents.length === 0) return false;
  todayEventsWithoutPastEvents.sort(compareEventsByStartTime);
  return todayEventsWithoutPastEvents[0].id === selectedId;
};

const DailyEvents = ({
  events,
  currentDateString,
  shouldDisplayEmptyEntertainmentCard,
  shouldDisplayEmptySplashCard,
  dateIndex,
  deleteEntertainment,
  resId,
  siteCode,
  getBookedEntertainments,
  getAvailableEntertainments,
  removeDining,
}) => {
  const dateColor = getDayLabelColor(dateIndex);
  return (
    <div className={classnames('daily-events', { first: dateIndex === 0 })}>
      <div className={classnames('day-label', dateColor)}>{getDayLabel(currentDateString)}</div>
      {
        events.map(({
          id,
          name,
          location,
          startTime,
          endTime,
          startDate,
          slotColor,
          numOfGuests,
          isPastEvent,
          isBMEItem,
          isDineAroundItem,
          type,
        }, index) => {
          const isHappeningToday = moment().isSame(startDate, 'day');
          const isHappeningNext = getIsHappeningNext(events, startDate, id);
          return (
            <Fragment key={index}>
              {
                index === 0 && events.length > 1 && (
                  <div
                    className={classnames(
                      'time-line',
                      shouldDisplayEmptyEntertainmentCard && 'no-entertainment',
                      isHappeningNext && 'next',
                    )}
                  />
                )
              }
              <BookedEventCard
                eventId={id}
                name={name}
                location={location}
                startTime={startTime}
                startDate={startDate}
                endTime={endTime}
                slotColor={slotColor}
                isHappeningNext={isHappeningNext}
                isHappeningToday={isHappeningToday}
                numOfGuests={numOfGuests}
                isPastEvent={isPastEvent}
                isBMEItem={isBMEItem}
                isDineAroundItem={isDineAroundItem}
                deleteEntertainment={deleteEntertainment}
                getBookedEntertainments={getBookedEntertainments}
                getAvailableEntertainments={getAvailableEntertainments}
                resId={resId}
                siteCode={siteCode}
                removeDining={removeDining}
                isEntertainment={type === entertainmentType}
              />
            </Fragment>
          );
        })
      }
      {shouldDisplayEmptyEntertainmentCard && <EmptyEntertainmentCard />}
      {shouldDisplayEmptySplashCard && <EmptyEntertainmentCard type={swimmingPage} />}
    </div>
  );
};

DailyEvents.propTypes = {
  events: PropTypes.array.isRequired,
  currentDateString: PropTypes.string.isRequired,
  shouldDisplayEmptyEntertainmentCard: PropTypes.bool.isRequired,
  shouldDisplayEmptySplashCard: PropTypes.bool.isRequired,
  dateIndex: PropTypes.number.isRequired,
  deleteEntertainment: PropTypes.func.isRequired,
  getBookedEntertainments: PropTypes.func.isRequired,
  getAvailableEntertainments: PropTypes.func.isRequired,
  resId: PropTypes.number.isRequired,
  siteCode: PropTypes.string.isRequired,
  removeDining: PropTypes.func.isRequired,
};

export default DailyEvents;
